import { IState } from 'shared/store';

export const selectNewbuildingTourBannerImageUrl = (state: IState): string | null =>
  state.offerData.tours?.newbuildingTour?.tourBannerImageUrl || null;
